module.exports = __webpack_public_path__ + "img/have_bundle_items.b78ba9b3.png";